'use client'
import { AnchorHTMLAttributes, cloneElement, ReactElement } from 'react'
import { useTrackerConfig } from './tracker-context'
import { TrackerProps } from '@avia/tracker'

interface TrackRouteProps extends TrackerProps {
  children: ReactElement<AnchorHTMLAttributes<HTMLAnchorElement>>
  disabled?: boolean
}

export function TrackRoute({ children, config, disabled }: TrackRouteProps) {
  const [mergedConfig] = useTrackerConfig(config)

  return cloneElement(children, {
    onClick: (e) => {
      const { onClick } = children.props
      tracker.click(mergedConfig)
      if (!disabled) {
        tracker.navigate(mergedConfig)
      }
      onClick?.(e)
    },
  })
}
